import { ref, computed } from "@vue/composition-api";
import AppModule from "../store/modules/app";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default (account_id) => {
    const { fetchClassifiers, custom_fields } = AppModule();

    const accountId = ref(account_id);

    const projectFields = computed(() => {
        if (!accountId.value) return [];
        if (custom_fields.value[accountId.value] === undefined || custom_fields.value[accountId.value].length === 0)
            return [];
        return custom_fields.value[accountId.value].filter(x => x.related_type.startsWith("project."));
    });

    const loadClassifiers = () => {
        if (!accountId.value) return;
        fetchClassifiers({ types: ['project_types', 'custom_fields'], account_id: accountId.value })
            .catch(ex => errorDialog.showError(ex));
    };
    const setAccountId = (new_account_id) => {
        accountId.value = new_account_id;
        loadClassifiers();
    }

    return {
        projectFields,
        setAccountId
    };
}